import AppError from '../errors/AppError';
import { useAuth } from '../hooks/auth';
import { ICustomerPortalUpdateUser } from '../interfaces/ICustomerPortalUpdateUser';
import { ICustomerPortalUserCustomer } from '../interfaces/ICustomerPOrtalUserCustomer';
import { IPaginationReturn } from '../interfaces/IPaginationReturn';
import { useRequest } from './useRequest';

interface IData {
  id: string;
  password: string;
  passwordConfirmation: string;
}
const useCustomerPortalUsersService = () => {
  const requestCustomerUserCustomer = useRequest<ICustomerPortalUserCustomer>();
  const requestActivateCustomerUser = useRequest<void>();
  const path = 'customer-portal-users';
  const auth = useAuth();
  const findAllCustomerPortalUser = async (
    queryParams: string,
  ): Promise<IPaginationReturn<ICustomerPortalUserCustomer[]>> => {
    return await requestCustomerUserCustomer
      .getManyPaginated({ path: `${path}?${queryParams}`, sendAuthorization: true })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message, error.status);
      });
  };
  const findAllCustomerPortalUserByIdCustomer = async (
    queryParams: string,
    IdCustomer: string,
  ): Promise<IPaginationReturn<ICustomerPortalUserCustomer[]>> => {
    return await requestCustomerUserCustomer
      .getManyPaginated({
        path: `${path}/customer/${IdCustomer}?${queryParams}`,
        sendAuthorization: true,
        headers: {
          tenantDomain: auth.state.tenantDomain,
        },
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message, error.status);
      });
  };

  const activeCustomerPortalUser = async (id: string): Promise<void> => {
    return await requestActivateCustomerUser
      .patch({
        path: `${path}/active/${id}`,
        sendAuthorization: true,
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message, error.status);
      });
  };
  const inactiveCustomerPortalUser = async (id: string): Promise<void> => {
    return await requestActivateCustomerUser
      .patch({
        path: `${path}/inactive/${id}`,
        sendAuthorization: true,
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message, error.status);
      });
  };

  const updatePasswordCustomerPortalUser = async ({ id, password, passwordConfirmation }: IData): Promise<void> => {
    return await requestActivateCustomerUser
      .put({
        path: `${path}/password/${id}`,
        sendAuthorization: true,
        body: {
          password,
          passwordConfirmation,
        },
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message, error.status);
      });
  };
  const updateCustomerPortalUser = async (data: ICustomerPortalUpdateUser): Promise<void> => {
    return await requestActivateCustomerUser
      .put({
        path: `${path}/${data.id}`,
        body: {
          name: data.name,
          email: data.email,
          phoneNumber: data.phoneNumber,
        },
        sendAuthorization: true,
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message, error.status);
      });
  };

  return {
    findAllCustomerPortalUser,
    activeCustomerPortalUser,
    inactiveCustomerPortalUser,
    updatePasswordCustomerPortalUser,
    findAllCustomerPortalUserByIdCustomer,
    updateCustomerPortalUser,
  };
};

export { useCustomerPortalUsersService };
